// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { boolean, string } from "@altostra/type-validations/lib/primitives";

export const isPatchEngagementCampaignsAppGroupIdCampaignIdAutoStopExemptionResult = objectOf({
  id: string,
  never_auto_stop: boolean,
  active_changelog_id: string,
});
